import { keyframes } from '@emotion/react';
import { Box } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';


const LOCKED_STYLE = {
    ring: ['#3A4A4C', '#2A3839', '#1A2B2E'],
    glow: 'rgba(0, 0, 0, 0.35)',
    color: '#5A6B6A',
};

const shimmerSweep = keyframes`
    0% { transform: translateX(-130%) skewX(-18deg); opacity: 0; }
    15% { opacity: 1; }
    60% { transform: translateX(260%) skewX(-18deg); opacity: 0; }
    100% { transform: translateX(260%) skewX(-18deg); opacity: 0; }
`;

const AchievementMedallion = ({ icon, tier, size = 132, shimmer = false }) => {
    const isLocked = tier === null;
    const style = isLocked ? LOCKED_STYLE : tier.style;
    const ringGradient = `linear-gradient(135deg, ${style.ring.join(', ')})`;

    return (
        <Box
            sx={{
                position: 'relative',
                width: size,
                height: size,
                borderRadius: '50%',
                padding: '5px',
                background: ringGradient,
                boxShadow: (theme) =>
                    theme.palette.mode === 'dark'
                        ? `0 0 22px ${style.glow}, 0 6px 18px rgba(0, 0, 0, 0.45)`
                        : `0 0 8px ${style.glow}, 0 4px 10px rgba(0, 0, 0, 0.10)`,
                flexShrink: 0,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                alignSelf: 'flex-start'
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    width: '100%',
                    height: '100%',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    backgroundColor: 'background.default',
                }}
            >
                <Box
                    component="img"
                    src={icon}
                    alt=""
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        transition: 'filter 0.3s ease',
                        filter: isLocked ? 'grayscale(1) brightness(0.5)' : 'none',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        background:
                            'linear-gradient(135deg, rgba(255, 255, 255, 0.55) 0%, rgba(255, 255, 255, 0.08) 35%, transparent 55%)',
                        pointerEvents: 'none',
                    }}
                />
                {shimmer && (
                    <Box
                        sx={{
                            position: 'absolute',
                            top: '-25%',
                            left: 0,
                            height: '150%',
                            width: '42%',
                            background:
                                'linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.6) 50%, transparent 100%)',
                            filter: 'blur(3px)',
                            transform: 'translateX(-130%) skewX(-18deg)',
                            animation: `${shimmerSweep} 3.5s ease-in-out infinite`,
                            pointerEvents: 'none',
                        }}
                    />
                )}
                {isLocked && (
                    <Box
                        sx={{
                            position: 'absolute',
                            inset: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#7A8E8C',
                        }}
                    >
                        <LockIcon sx={{ fontSize: size * 0.26 }} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default AchievementMedallion;
